import axios from './http'


/**
 * 获取表单key
 * @returns {Promise<AxiosResponse<any>>}
 */
function formKey() {
  return axios.get('/v1/form_key')
}

/**
 * 验证验证码是否正确
 * @param formKey
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 */
function verifyImgCode(formKey, code) {
  return axios.post('/v1/img_verifier', {"form_key": formKey, "code":code})
}

/**
 * 重新发送短信
 * @param phone
 * @param formKey
 * @param value
 * @param re
 * @returns {Promise<AxiosResponse<any>>}
 */
function sendSms(phone, formKey, value, re) {
  return axios.get('/v1/sms/code', {
    params: {
      phone: phone,
      form_key: formKey,
      value: value,
      re: re
    }
  })
}

/**
 * 图片验证码地址
 */
function verifyCodeImg(formKey) {
  return axios.get('/v1/img_verifier', {params:{"form_key": formKey}})
}

/**
 * 地区
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 */
function regions(code) {
  return axios.get('/v1/regions', {params: {code: code}})
}


function industry(parent_id) {
  return axios.get('/v1/industry', {params:{parent_id}})
}

/**
 * 发送邮箱验证码
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
function sendMail(email) {
  return axios.get('/v1/email/code', {
    params: {
      email: email,
    }
  })
}

/**
 * 行业
 * @returns {Promise<AxiosResponse<any>>}
 */
// function industry() {
//   return axios.get('/v1/industry')
// }

/**
 * 企业规模
 * @returns {Promise<AxiosResponse<any>>}
 */
function entScale() {
  return axios.get('/v1/ent/scale')
}

export default {
  formKey,
  verifyImgCode,
  sendSms,
  verifyCodeImg,
  regions,
  industry,
  sendMail,
  entScale,
}
